<template>
  <div>
    <vue-cal
      locale="fr"
      active-view="month"
      :disable-views="['years', 'year']"
      class="vuecal--blue-theme"
      events-on-month-view="short"
      :events="events"
      @ready="fetchEvents"
      @view-change="fetchEvents"
      :on-event-click="onEventClick"
    >
      <template #event="{ event }">
        <!-- <v-icon>{{ event.icon }}</v-icon> -->

        <div class="vuecal__event-title">
          <i
            class="mdi mdi-checkbox-blank-circle mr-1"
            :style="`color: ${event.statut.couleur}`"
          ></i>
          {{ event.statut.nom }}
        </div>
        <small class="vuecal__event-time">
          <!-- Using Vue Cal Date prototypes (activated by default) -->
          <span class="mr-1">{{ event.start.formatTime('HH:mm') }}</span
          >-
          <span class="ml-1">{{ event.end.formatTime('HH:mm') }}</span>
        </small>
      </template>
    </vue-cal>
    <ShowEventModal
      :modalID="modalName"
      :modalTitle="titleModal"
      :nettoyage="nettoyage"
    />
  </div>
</template>

<script>
// Documentation: https://antoniandre.github.io/vue-cal

import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import EMPLOYE_URL from '@/http/rh/employe';
import NETTOYAGE_URL from '@/http/nettoyage';
import ShowEventModal from './ShowEventModal.vue';

export default {
  components: { VueCal, ShowEventModal },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      events: [],
      titleModal: "Aperçu d'un evenement",
      modalName: 'modal-evenement',
      nettoyage: {},
    };
  },

  methods: {
    fetchEvents({ startDate, endDate }) {
      window.axios
        .get(EMPLOYE_URL.GET_PLANNING_CALENDAR(this.id), {
          params: {
            date_debut: this.$options.filters.formatDate(
              startDate,
              'DD/MM/YYYY'
            ),
            date_fin: this.$options.filters.formatDate(endDate, 'DD/MM/YYYY'),
          },
        })
        .then((resp) => {
          this.events = resp.data.data.map((i) => {
            i.class = 'nettoyage';
            return i;
          });
        })
        .catch();
    },
    async onEventClick(event) {
      this.nettoyage = {};

      await window.axios
        .get(NETTOYAGE_URL.NETTOYAGE_CALENDAR + '/' + event.id)
        .then((resp) => {
          this.nettoyage = resp.data.nettoyage;
        });
      await this.$bvModal.show(this.modalName);
    },
  },
};
</script>

<style>
.vuecal {
  height: 90vh;
}

.nettoyage {
  background: rgb(204, 227, 254);
  border-bottom: 1px solid rgb(18, 37, 59);
}

.vuecal__menu,
.vuecal__cell-events-count {
  background-color: #4366a0 !important;
}
.vuecal__title-bar {
  background-color: #c9dcfc !important;
}
.vuecal__cell--today,
.vuecal__cell--current {
  background-color: rgba(240, 240, 255, 0.4);
}
.vuecal:not(.vuecal--day-view) .vuecal__cell--selected {
  background-color: rgba(235, 255, 245, 0.4) !;
}
.vuecal__cell--selected:before {
  border-color: rgba(66, 185, 131, 0.5);
}
/* Cells and buttons get highlighted when an event is dragged over it. */
.vuecal__cell--highlighted:not(.vuecal__cell--has-splits),
.vuecal__cell-split--highlighted {
  background-color: rgba(195, 255, 225, 0.5);
}
.vuecal__arrow.vuecal__arrow--highlighted,
.vuecal__view-btn.vuecal__view-btn--highlighted {
  background-color: rgba(136, 236, 191, 0.25);
}
</style>
